import {
  Sidebar,
  SidebarContent,
  SidebarHeader,
  SidebarRail,
} from '@/components/ui/sidebar'
import { NavGroup } from '@/components/layout/nav-group'
import { TeamSwitcher } from '@/components/layout/team-switcher'
import {
  SidebarSkeleton,
} from './components/sidebar-skeleton'
import { useSidebarData } from './data/sidebar-data'
import useSidebarRenderingByFeatures from './hooks/sidebar-rendering-by-features'
import useSidebarRendering from './hooks/sidebar-rendering-by-plan'

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const sidebarData = useSidebarData()
  const { filteredSidebarDataByPlanType } = useSidebarRendering({ sidebarData })
  const { mainNavGroups, footerNavGroups } = useSidebarRenderingByFeatures({
    filteredSidebarDataByPlanType,
  })

  if (sidebarData.isLoading) {
    return (
      <Sidebar collapsible='icon' variant='floating' {...props}>
        <div className='flex h-full flex-col'>
          <SidebarHeader>
            <TeamSwitcher />
          </SidebarHeader>
          <div className='min-h-0 flex-1'>
            <SidebarContent className='h-full'>
              <SidebarSkeleton />
            </SidebarContent>
          </div>
          <div className='border-t border-sidebar-border'>
            <SidebarContent className='pb-4'>
              <SidebarSkeleton />
            </SidebarContent>
          </div>
        </div>
        <SidebarRail />
      </Sidebar>
    )
  }

  return (
    <Sidebar collapsible='icon' variant='floating' {...props}>
      <div className='flex h-full flex-col'>
        <SidebarHeader>
          <TeamSwitcher />
        </SidebarHeader>

        <div className='min-h-0 flex-1'>
          <SidebarContent className='h-full'>
            {(mainNavGroups || []).map((props) => (
              <NavGroup key={props.title} {...props} />
            ))}
          </SidebarContent>
        </div>

        <div className='border-t border-sidebar-border'>
          <SidebarContent className='pb-4'>
            {(footerNavGroups || []).map((props) => (
              <NavGroup key={props.title} {...props} />
            ))}
          </SidebarContent>
        </div>
      </div>
      <SidebarRail />
    </Sidebar>
  )
}
